// @ts-nocheck
import {TimePicker as TimePickerAntd, type TimePickerProps, type TimeRangePickerProps} from 'antd'
import React, {useEffect, useRef} from 'react'
import '../LabelText/index.less'
// import {MergedTimePicker} from 'antd/lib/time-picker'

export type TimePickerYdcProps = TimePickerProps & TimeRangePickerProps & {prefix?: string}

const TimePicker = ({prefix = '', ...props}: TimePickerYdcProps) => {
  const r = useRef<any>()
  const addPrefix = () => {
    if (r.current?.nativeElement?.querySelector('astro-ui-label-text')) {
      return
    }

    const label = document.createElement('span')
    label.className = 'astro-ui-label-text input-prefix'
    label.innerHTML = prefix
    r.current?.nativeElement?.insertBefore(label, r.current?.nativeElement?.firstChild)
  }
  useEffect(() => {
    if (prefix) {
      addPrefix()
    }
  }, [prefix])

  return <TimePickerAntd ref={r} {...props} />
}

const RangePicker = ({prefix = '', ...props}: TimePickerYdcProps) => {
  const r = useRef<any>()
  const addPrefix = () => {
    if (r.current?.nativeElement?.querySelector('astro-ui-label-text')) {
      return
    }

    const label = document.createElement('span')
    label.className = 'astro-ui-label-text input-prefix'
    label.innerHTML = prefix
    r.current?.nativeElement?.insertBefore(label, r.current?.nativeElement?.firstChild)
  }
  useEffect(() => {
    if (prefix) {
      addPrefix()
    }
  }, [prefix])

  return <TimePickerAntd.RangePicker ref={r} {...props} />
}

TimePicker.RangePicker = RangePicker

export default TimePicker
